// extracted by mini-css-extract-plugin
export var childrenContainer = "_58-0";
export var virtualScrollArea = "_58-1";